class SelectObjectScreenerCriteria extends Tango.Component {
    widgetDidMount() { this._bind(); }
    widgetContentChanged() { this._bind(); }

    _bind() {
        const root = document.getElementById(this.root);
        if (!root) return;

        const input = root.querySelector('.sos-search');
        if (!input) return;

        const rows = [...root.querySelectorAll('.checkboxlist > label')].map(label => {
            const span = label.querySelector('.sos-text');
            const text = (span ? span.textContent : label.textContent).trim();
            return { label, span, text, lower: text.toLowerCase() };
        });

        const filter = () => {
            const q = input.value.trim().toLowerCase();
            for (const r of rows) {
                if (!q) {
                    r.label.style.display = '';
                    if (r.span) r.span.textContent = r.text;
                    continue;
                }

                const idx = r.lower.indexOf(q);
                if (idx < 0) {
                    r.label.style.display = 'none';
                    continue;
                }

                r.label.style.display = '';
                if (r.span) {
                    const mark = document.createElement('mark');
                    mark.textContent = r.text.slice(idx, idx + q.length);
                    r.span.textContent = '';
                    r.span.append(
                        document.createTextNode(r.text.slice(0, idx)),
                        mark,
                        document.createTextNode(r.text.slice(idx + q.length)));
                }
            }
        };

        input.addEventListener('input', filter);
        input.focus();
    }
}

Tango.registerComponent(SelectObjectScreenerCriteria);
